import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverTeamsFilterEntity } from '../../domain/entities/DriverTeamsFilterEntity'

export class DriverTeamsFilterModel extends DriverTeamsFilterEntity {
  driverId?: number
  constructor(dataDto: DriverTeamsFilterEntity) {
    super()
    mapEntityProperties<DriverTeamsFilterModel>(this, dataDto, {
      exclude: ['driver'],
      map: {
        driverId: dataDto.driver?.id
      }
    })
  }
}
